import React from 'react';

const ProductSystemItemContext = React.createContext({
    productSystemItems: [],
    set_product_system_items: (jsonData) => { return {asdf: null}}
})

export default ProductSystemItemContext;

